/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Merchant session object returned by Apple for completeMerchantValidation.
 * @export
 * @interface ApplePayMerchantSession
 */
export interface ApplePayMerchantSession {
    /**
     * Timestamp in milliseconds when the session was created.
     * @type {number}
     * @memberof ApplePayMerchantSession
     */
    epochTimestamp?: number;
    /**
     * Timestamp in milliseconds when the session expires.
     * @type {number}
     * @memberof ApplePayMerchantSession
     */
    expiresAt?: number;
    /**
     * Unique identifier for the merchant session.
     * @type {string}
     * @memberof ApplePayMerchantSession
     */
    merchantSessionIdentifier?: string;
    /**
     * Cryptographic nonce from Apple.
     * @type {string}
     * @memberof ApplePayMerchantSession
     */
    nonce?: string;
    /**
     * Merchant identifier.
     * @type {string}
     * @memberof ApplePayMerchantSession
     */
    merchantIdentifier?: string;
    /**
     * Verified domain name.
     * @type {string}
     * @memberof ApplePayMerchantSession
     */
    domainName?: string;
    /**
     * Merchant display name.
     * @type {string}
     * @memberof ApplePayMerchantSession
     */
    displayName?: string;
    /**
     * Cryptographic signature from Apple.
     * @type {string}
     * @memberof ApplePayMerchantSession
     */
    signature?: string;
}

/**
 * Check if a given object implements the ApplePayMerchantSession interface.
 */
export function instanceOfApplePayMerchantSession(value: object): value is ApplePayMerchantSession {
    return true;
}

export function ApplePayMerchantSessionFromJSON(json: any): ApplePayMerchantSession {
    return ApplePayMerchantSessionFromJSONTyped(json, false);
}

export function ApplePayMerchantSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplePayMerchantSession {
    if (json == null) {
        return json;
    }
    return {
        
        'epochTimestamp': json['epochTimestamp'] == null ? undefined : json['epochTimestamp'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
        'merchantSessionIdentifier': json['merchantSessionIdentifier'] == null ? undefined : json['merchantSessionIdentifier'],
        'nonce': json['nonce'] == null ? undefined : json['nonce'],
        'merchantIdentifier': json['merchantIdentifier'] == null ? undefined : json['merchantIdentifier'],
        'domainName': json['domainName'] == null ? undefined : json['domainName'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'signature': json['signature'] == null ? undefined : json['signature'],
    };
}

export function ApplePayMerchantSessionToJSON(json: any): ApplePayMerchantSession {
    return ApplePayMerchantSessionToJSONTyped(json, false);
}

export function ApplePayMerchantSessionToJSONTyped(value?: ApplePayMerchantSession | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'epochTimestamp': value['epochTimestamp'],
        'expiresAt': value['expiresAt'],
        'merchantSessionIdentifier': value['merchantSessionIdentifier'],
        'nonce': value['nonce'],
        'merchantIdentifier': value['merchantIdentifier'],
        'domainName': value['domainName'],
        'displayName': value['displayName'],
        'signature': value['signature'],
    };
}

